import moment from "moment";

// SAMPLE VUE FILTERS, INSERTED HERE ONLY TO SHOW YOU
// HOW WE USUALLY HANDLE FILTERS

const SAMPLE_STD_DATE = "DD/MM/YYYY";
const SAMPLE_STD_TIME = "HH:mm";
const SAMPLE_STD_DATE_TIME = "DD/MM/YYYY HH:mm";

export default [
  {
    name: "dformat",
    fun: function (value) {
      if (!value) return "";
      var d = new Date(value);
      return moment(d).format(SAMPLE_STD_DATE);
    }
  },
  {
    name: "tformat",
    fun: function (value) {
      if (!value) return "";
      var d = new Date(value);
      return moment(d).format(SAMPLE_STD_TIME);
    }
  },
  {
    name: "dtformat",
    fun: function (value) {
      if (!value) return "";
      var d = new Date(value);
      return moment(d).format(SAMPLE_STD_DATE_TIME);
    }
  }
];
